module.exports = __webpack_public_path__ + "static/96-31ff3e1b70fc579753d4b08ed5f8c369.png";